export default __webpack_public_path__ + "static/media/prescription.335c6c0e.svg";